import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AppRoutes } from "./router";
import { releaseScrollLock, isScrollLocked } from "./lib/scrollLock";

function Dirs21Rebinder() {
  const location = useLocation();
  useEffect(() => {
    const timer = setTimeout(() => {
      if ((window as any).dirs21) {
        try {
          (window as any).dirs21.rebindTriggers();
        } catch (e) {}
      }
    }, 500);
    return () => {
      clearTimeout(timer);
      try {
        if ((window as any).dirs21) {
          (window as any).dirs21.unmountAll?.();
        }
      } catch (e) {}
    };
  }, [location.pathname]);
  return null;
}

// Das DIRS21-Vollbildfenster sperrt beim Oeffnen das Scrollen und gibt es beim
// Schliessen nicht zuverlaessig wieder frei. Zwei Notbremsen:
//   1. bei jedem Seitenwechsel
//   2. sobald das Vollbildfenster aus der Seite verschwindet
function ScrollLockGuard() {
  const location = useLocation();

  useEffect(() => {
    releaseScrollLock();
  }, [location.pathname]);

  useEffect(() => {
    // Liegt noch ein DIRS21-Element als Vollbild ueber der Seite?
    const overlayOffen = () =>
      Array.from(
        document.querySelectorAll<HTMLElement>('[id*="dirs21"], [class*="dirs21"], [id*="d21"], [class*="d21"]'),
      ).some((el) => getComputedStyle(el).position === "fixed" && el.offsetHeight > 0);

    let timer: number | undefined;
    const pruefen = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (isScrollLocked() && !overlayOffen()) releaseScrollLock();
      }, 150);
    };

    const beobachter = new MutationObserver(pruefen);
    beobachter.observe(document.body, { childList: true, subtree: true });
    return () => {
      beobachter.disconnect();
      window.clearTimeout(timer);
    };
  }, []);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Dirs21Rebinder />
        <ScrollLockGuard />
        <Routes>
          <Route path="*" element={<AppRoutes />} />
        </Routes>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;